// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import { store } from './store'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload)

import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";

Sentry.init({
  dsn: "https://3004116c8b09494eae402f5e32281ff5@o291654.ingest.sentry.io/5454833",
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
    }),
    new Integrations.BrowserTracing(),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});


Vue.config.productionTip = false

/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  store: store,
  template: '<App/>',
  components: { App }
})

window.vm = vm;



// WEBPACK FOOTER //
// ./src/main.js